export default "__VITE_ASSET__ynhERNeJ__"